import React from 'react';
import { lazy } from 'react';

const Login = lazy(() => import('./Login/Login'));
const Passwort = lazy(() => import('./Login/Password'));
const PasswordRecovery = lazy(() => import('./Login/PasswordRecovery'));
const PublicSearch = lazy(() => import('./Login/PublicSearch'));
const AppointmentCalendar = lazy(() => import('./Login/Appointment'));
const PublicContact = lazy(() => import('./Login/PublicContact'));
const AppointmentContact = lazy(() => import('./Login/AppointmentContact'));
const HeatmapRender = lazy(() => import('./Login/Heatmap'));

const Timeslots = lazy(() => import('./School/Timeslots'));
const CreateTimeslot = lazy(() => import('./School/CreateTimeslot'));
const CreateTimeslotSeries = lazy(() => import('./School/CreateTimeslotSeries'));
const BlockedBusinesses = lazy(() => import('./School/BlockedBusinesses'));
const SchoolBusiness = lazy(() => import('./School/Business'));

const OwnTimeslots = lazy(() => import('./Business/OwnTimeslots'));
const SearchTimeslots = lazy(() => import('./Business/SearchTimeslots'));
const Abo = lazy(() => import('./Business/Abo'));
const AdditionalAbo = lazy(() => import('./Business/AdditionalAbo'));
const AdditionalContingent = lazy(() => import('./Business/AdditionalContingent'));
const UpgradeAbo = lazy(() => import('./Business/UpgradeAbo'));

const School = lazy(() => import('./Register/School'));
const Business = lazy(() => import('./Register/Business'));
const UserRegistration = lazy(() => import('./Register/User'));

const User = lazy(() => import('./User/User'));
const UserPassword = lazy(() => import('./User/UserPassword'));

const Contactperson = lazy(() => import('./User/Contactperson'));
const Organisation = lazy(() => import('./User/Organisation'));
const Userlist = lazy(() => import('./User/Userlist'));
const NewsletterOptOut = lazy(() => import('./User/NewsletterOptOut'));
const ContactMail = lazy(() => import('./User/ContactMail'));

const Invite = lazy(() => import('./Mailing/Invite'));

const News = lazy(() => import('./News/News'));
const NewsArticle = lazy(() => import('./News/NewsArticle'));



const routeConfig = [
    {
        path: "/",
        component: <PublicSearch />
    },
    {
        path: "/kontakt",
        component: <PublicContact />
    },
    {
        path: "/vorfuehrtermine-kontakt",
        component: <AppointmentContact />
    },
    {
        path: "/umkreissuche",
        component: <PublicSearch />
    },
    {
        path: "/vorfuehrtermine",
        component: <AppointmentCalendar />
    },
    {
        path: "/Home/Appointment",
        component: <AppointmentCalendar />
    },
    {
        path: "/Login/Login",
        component: <Login />
    },
    {
        path: "/Login/Password",
        component: <Passwort />
    },
    {
        path: "/passwort-wiederherstellen",
        component: <PasswordRecovery />
    },
    {
        path: "/meine-termine",
        component: <Timeslots />
    },
    {
        path: "/neuer-termin",
        component: <CreateTimeslot />
    },
    {
        path: "/neue-terminserie",
        component: <CreateTimeslotSeries />
    },
    {
        path: "/geblockte-unternehmen",
        component: <BlockedBusinesses />
    },
    {
        path: "/geblockte-unternehmen/.*",
        component: <SchoolBusiness />
    },
    {
        path: "/termine",
        component: <OwnTimeslots />
    },
    {
        path: "/terminsuche",
        component: <SearchTimeslots />
    },
    {
        path: "/abonnement",
        component: <Abo />
    },
    {
        path: "/abonnement-hinzufuegen",
        component: <AdditionalAbo />
    },
    {
        path: "/kontingent-hinzufuegen/.*",
        component: <AdditionalContingent />
    },
    {
        path: "/abonnement-upgraden/.*",
        component: <UpgradeAbo />
    },
    {
        path: "/Register/School",
        component: <School />
    },
    {
        path: "/Register/Business",
        component: <Business />
    },
    {
        path: "/Register/User/.*",
        component: <UserRegistration />
    },
    {
        path: "/registrierung/schule",
        component: <School />
    },
    {
        path: "/registrierung/unternehmen",
        component: <Business />
    },
    {
        path: "/registrierung/benutzer/.*",
        component: <UserRegistration />
    },
    {
        path: "/benutzerdaten",
        component: <User />
    },
    {
        path: "/passwort-aendern",
        component: <UserPassword />
    },
    {
        path: "/kontaktpersonen",
        component: <Contactperson />
    },
    {
        path: "/organisationsdaten",
        component: <Organisation />
    },
    {
        path: "/benutzerverwaltung",
        component: <Userlist />
    },
    {
        path: "/newsletter-abmelden",
        component: <NewsletterOptOut />
    },
    {
        path: "/benutzerkontakt",
        component: <ContactMail />
    },
    {
        //path: "/Mailing/Invite",
        path: "/benutzer-einladen",
        component: <Invite />
    },
    {
        path: "/aktuelles",
        component: <News />
    },
    {
        path: "/aktuelles/.*",
        component: <NewsArticle />
    },
    {
        path: "/heatmap",
        component: <HeatmapRender />
    }
];

export default routeConfig;